import React, { ReactElement } from 'react';
import useFeatureToggleService from 'feature-toggle';
import { AssigneeWidgetLayoutProps, UserLogoSize } from './types';
import { UrlImage } from '../../UrlImage';

import styles from './AssigneeWidgetLayout.module.scss';
import { Badge } from '../../Badge';
import ShadcnAssigneeWidgetLayout from './ShadcnAssigneeWidgetLayout';

export default function AssigneeWidgetLayoutWeb(
  props: AssigneeWidgetLayoutProps,
) {
  const { isShadcnUiEnabled } = useFeatureToggleService();

  if (isShadcnUiEnabled()) {
    return <ShadcnAssigneeWidgetLayout {...props} />;
  } else {
    return <LegacyAssigneeWidgetLayout {...props} />;
  }
}

function LegacyAssigneeWidgetLayout(
  props: AssigneeWidgetLayoutProps,
) {
  const withName = props.withName || false;
  const isFloat = true;

  let element: ReactElement;

  const className = `${styles.userLogo} ${props.logoSize || UserLogoSize.BIG} ${isFloat ? styles.float : ''} ${props.withName ? styles.withMargin : ''}`;

  const title = props.avatarTitle || props.profile.name.fullName;

  if (props.profile._avatarUrl) {
    element = (
      <div
        className={[
          className,
          props.onClick ? styles.clickable : '',
        ].join(' ')}
        onClick={props.onClick}
      >
        <UrlImage
          src={props.profile._avatarUrl.resized}
          className={className}
          title={title}
          alt={props.profile.name.fullName}
        />
        {props.badge && (<Badge number={props.badge} title={props.badgeTitle} withBorder />)}
      </div>

    );
  } else {
    element = (
      <div
        className={[
          className,
          props.onClick ? styles.clickable : '',
        ].join(' ')}
        onClick={props.onClick}
        title={title}
      >
        {props.profile.name.firstName.trim()
          .charAt(0)}
        {props.profile.name.lastName.trim()
          .charAt(0)}
        {props.badge && (<Badge number={props.badge} title={props.badgeTitle} withBorder />)}
      </div>
    );
  }

  const additionalInfo = React.Children.toArray(props.additionalInfo);

  return (
    <>
      {element}
      <div className={styles.detailsContainer}>
        {withName && (
          <div className={styles.userName}>
            {props.profile.name.fullName}
          </div>
        )}
        {props.additionalInfo && (
          <div>
            {additionalInfo.map((item, index) => {
                return (
                  <div key={index} className={styles.additionalInfo}>
                    {item}
                  </div>
                )
              }
            )}
          </div>
        )}
      </div>

    </>
  );
}
